import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { Input, Select, FallbackImage, Render, Button, Table, Pagination, Modal } from 'components';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { SearchBlueIcon } from 'assets/icons';
import { DriverService } from 'services';
import ModalCreate from './modal-create';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	search_by: ''
}

class Drivers extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Nombre',
			'Correo',
			'Teléfono',
			'Ciudad',
			'Opciones'
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Invitaciones Enviadas',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading = false) => {
		const res: any = await DriverService.invitations.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form
		});
		this.setState({
			data: res.invitations?.rows || [],
			last_page: res.invitations?.count || 1
		},() => {
			// @ts-ignore
			if (this.props.location.state?.create) {
				this.props.history.replace({
		            pathname: this.props.location.pathname,
		            state: {}
		        });
				this.invitation();
			}
		});
	}

	submit = async (e: any) => {
		e.preventDefault();
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	onClose = () => {
		this.setState({
			visible: false
		},() => {
			this.load(true);
		});
	}

	invitation = () => {
		this.setState({
			visible: true
		});
	}

	delete = (item: any) => {
		Globals.confirm('¿Desea eliminar la invitación?',async () => {
			await DriverService.invitations.delete({
				invitation_id: item.id
			});
			this.load(true);
		});
	}

	render() {
		const { visible } = this.state;

		return (
			<div id="drivers">
				<Modal
		          className="modal-create-invitation"
		          visible={ visible }
		          title="Enviar invitación"
		          onClose={ () => this.onClose() }
		        >
		        	{/*
		        	// @ts-ignore */}
		        	<ModalCreate
		        		onClose={ () => this.onClose() }
		        	/>
		      	</Modal>

				<div className="row" style={{ marginBottom: '20px', alignItems: 'center' }}>
					<div className="col-md-6">
						<p className="label-search">Filtrar usuario</p>
						<div className="container-search">
							<Select
								name="search_by"
								placeholder="Buscar por"
								onChange={ (e: any) => this.change(e) }
								value={ this.state.form.search_by }
								options={ [
									{ value: 'name', label: 'Nombre' },
									{ value: 'email', label: 'Correo' },
									{ value: 'phone', label: 'Teléfono' },
									{ value: 'city', label: 'Ciudad' },
								] }
							/>
							<Input
								value={ this.state.form.search }
								name="search"
								placeholder="Buscar"
								className="input-table"
								notMui
								searchRight
								searchIcon={ SearchBlueIcon }
								onSubmit={ () => this.load() }
								onChange={ (e: any) => {
									clearTimeout(this.timer);
									this.timer = setTimeout(() => {
										this.load(true);
									},1000);
									this.change(e); 
								} } />
						</div>
					</div>
					<div className="col-md-6 text-right">
						<button className="btn btn-add" onClick={ this.invitation }>
							<p>Invitar chofer</p>
							<div className="add">
								+
							</div>
						</button>
					</div>
				</div>

				<div className="tabs">
					<button
						type="button"
						className="tab"
						onClick={() => this.props.history.replace(`/${ this.props.user?.level_id == Constants.LEVELS.CLIENT ? 'client' : 'moderators' }/drivers`) }
						data-active={ false }
					>
						Usuarios
					</button>

					<button
						type="button"
						className="tab"
						onClick={() => {} }
						data-active={ true }
					>
						Invitaciones Enviadas
					</button>
				</div>
				<Table title="Conductores" data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i.name }</td>
								<td>{ i.email }</td>
								<td>{ i.phone }</td>
								<td>{ i.city }</td>
								<td>
									<button className="btn btn-delete" onClick={ () => this.delete(i) }>
										Eliminar
									</button>
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Drivers);